export default "__VITE_ASSET__DREMeXXL__"